/**
 * API Client Configuration for Falcon
 *
 * Uses the shared saas-shell createApiClients for consistent auth handling,
 * retry logic, and error management across all products.
 */

import { createApiClients } from '@roselabs-io/saas-shell'

// Helper to get required env var
const getRequiredEnv = (key: string): string => {
  const value = import.meta.env[key]
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`)
  }
  return value
}

// API URLs exported for backward compatibility
export const API_URL = getRequiredEnv('VITE_API_URL')
export const AUTH_API_URL = getRequiredEnv('VITE_AUTH_API_URL')
export const BILLING_API_URL = import.meta.env.VITE_BILLING_API_URL || API_URL

// Create configured API clients
const {
  productApiClient: apiClient,
  authApiClient,
  billingApiClient,
  platformApiClient,
  tokenManager,
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
} = createApiClients({
  authServiceUrl: AUTH_API_URL,
  productApiUrl: API_URL,
  billingApiUrl: BILLING_API_URL,
  storageKeyPrefix: 'falcon',
  productSlug: 'falcon',
})

// Re-export everything for backward compatibility
export {
  authApiClient,
  billingApiClient,
  platformApiClient,
  tokenManager,
  getAccessToken,
  getRefreshToken,
  setTokens,
  clearTokens,
}

export default apiClient
